<template>
  <gru-table
          :resource="resource"
          :fields="fields"
          :enabledExcel="false"
          :enabledPrint="false"
          :primaryKey="'id'"
  ></gru-table>
</template>

<script>
  export default {
    name: "NotificationTypeList",
    data() {
      return {
        resource: "notificationType",
      };
    },
    computed: {
      fields() {
        return [
          {
            text: "lang.notification.newTypeName",
            value: "typetext",
            sortable: true,
            editable: true
          },
          {
            text: "lang.notification.newTypeValue",
            value: "typevalue",
          },
          {
            text: "lang.notification.newTypeGetField",
            value: "typegetfield",
            optionValues: this.optionValues,
          },
        ];
      }
    }
  };
</script>

<style scoped></style>
